import BaseComponent from '../../../../../common/js/BaseComponent';
import StoreLocator from "../StoreLocator";

export default class Stock extends BaseComponent {
    init(): void {
        this.initEvents();
    }

    initEvents(): void {
        this.getShopsModal();
    }

    getShopsModal() {
        $('a[data-bs-target="#choose-shop"]').on('click', function (e) {
            e.preventDefault();// Empêche le comportement par défaut du lien
            // Effectuer une requête AJAX pour charger le contenu de la modale
            $.ajax({
                url: $(this).data('url'),  // Utiliser la route définie plus tôt
                type: 'GET',
                success: function (response) {
                    // Injecter le contenu récupéré dans la div de la modale
                    $('#choose-shop .modal-content').html(response);
                    // 1. Initialisation des composants TypeScript après l'injection
                    $('[data-mount="StoreLocator"]').each(function () {
                        // Assurez-vous que la classe StoreLocator est bien accessible
                        new StoreLocator(this); // `this` fait référence à l'élément DOM monté
                    });
                },
                error: function () {
                    alert('Erreur lors du chargement des données.');
                }
            });
        });
    }
}
